import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import {
  path,
  mergeDeepLeft,
  clone,
  map,
  filter,
} from 'ramda';
import Input from '../../common/Input';
import Select from '../../common/Select';
import TextArea from '../../common/TextArea';
import MultiSelect from '../../common/MultiSelect';
import fields from './fields';
import Breadcrumbs from '../../common/Breadcrumbs';
import { processFields } from '../../utils/prePost';
import { validateFields } from '../../utils/validate';
import '../../css/forms/default-forms.css';
import { createLane } from '../../api/boardLane';
import { fetchShops } from '../../api/shops';
import { getList } from '../../api/projects';
import { addNotification as notify } from 'reapop';


export class AddLane extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submit: false,
      errors: [],
      fields: fields,
    };
    this.submit = this.submit.bind(this);
    this.changeFormValue = this.changeFormValue.bind(this);
    this.cancel = this.cancel.bind(this);

    this.getProjectList = this.getProjectList.bind(this);
    this.getShopList = this.getShopList.bind(this);
    this.convertProjectList = this.convertProjectList.bind(this);
    this.addNotification = this.addNotification.bind(this);
  }

  componentWillMount() {
    this.props.shopList();
    this.props.projectList();
  }

  cancel() {
    this.props.goToBoardEditor();
  }

  getShopList() {
    const shopSource = path(['shops', 'list'], this.props) || [];
    const shopList = [{
      value: 0,
      text: 'Select Shop'
    }];

    for (let i = 0; i < shopSource.length; i++) {
      shopList.push({
        value: shopSource[i].id,
        text: shopSource[i].name,
      })
    }
    return shopList;
  }

  getProjectList() {
    const projectSource = path(['projects', 'list'], this.props) || [];
    const projectList = [];

    for (let i = 0; i < projectSource.length; i++) {
      projectList.push({
        value: projectSource[i].id,
        checked: false,
        label: projectSource[i].name,
      })
    }
    return projectList;
  }

  submit(e) {
    e.preventDefault();
    let result = validateFields(this.state.fields);
    if (result.check === false) {
      this.setState({
        fields: result.fields,
      });
    } else {
      let data = processFields(this.state.fields);
      data = this.convertProjectList(data)
      data.board_id = 1;
      if(data.project_ids.length === 0) {
        this.addNotification();
      }else {
        this.props.saveForm(data);
      }
    }
    return false;
  }

  addNotification() {
    this.props.addNotification();
  }

  convertProjectList(data) {
    if(data.project_ids.length > 0) {
      let selectedProjects = filter(item => item.checked, data.project_ids);
      data.project_ids = (map(item => item.value, selectedProjects)).join(',');
    }

    return data;
  }

  changeFormValue(field, newObject) {
    let stateClone = clone(this.state);
    stateClone.fields[field] = newObject;
    this.setState(mergeDeepLeft(stateClone, this.state));
  }

  render() {
    return (
      <div className="row">
        <div className="col">
          <Breadcrumbs list={[
           { url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard' },
           { url: '/pages/boardsettings', icon: 'settings', name: 'Board Settings' },
           { icon: 'add_box', name: 'Add Lane' },
           ]} />
          <div className="card rounded">
            <div className="card-header rounded-top">
              Add Lane
            </div>
            <div className="card-block">
              <div className="col-12" style={{ paddingBottom: '40px' }}>
                <button
                  className={'btn btn-danger btn-outline float-right'}
                  style={{ marginLeft: '10px' }}
                  onClick={this.cancel}
                >
                  <i className="fa fa-remove"></i>
                  <span style={{ paddingLeft: '3px' }}>Cancel</span>
                </button>
                <button className={'btn btn-success btn-outline float-right'} onClick={this.submit}>
                  <i className="fa fa-check"></i>
                  <span style={{ paddingLeft: '3px' }}>Save & Continue</span>
                </button>
              </div>
              <form onSubmit={this.submit}>
                <div className="col-12">
                  <Select
                    options={this.getShopList()}
                    field={this.state.fields['shop_id']}
                    onChange={this.changeFormValue}
                  />
                  <Input
                    field={this.state.fields['label']}
                    onChange={this.changeFormValue}
                  />
                  <TextArea
                    field={this.state.fields['description']}
                    onChange={this.changeFormValue}
                  />
                  <MultiSelect
                    options={this.state.fields['project_ids'].value.length > 0 ? this.state.fields['project_ids'].value : this.getProjectList()}
                    field={this.state.fields['project_ids']}
                    onChange={this.changeFormValue}
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    goToBoardEditor: () => {
      dispatch(push('/pages/boardsettings'));
    },
    saveForm: (data) => {
      createLane(data)(dispatch);
    },
    shopList: () => {
      fetchShops()(dispatch);
    },
    projectList: () => {
      getList()(dispatch);
    },
    addNotification: () => {
      dispatch(notify({
        title: 'Projects',
        message: 'Any project should be selected',
        status: 'error',
        position: 'tr',
        dismissible: true,
        dismissAfter: 3000,
      }));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddLane);



// WEBPACK FOOTER //
// ./src/containers/AddLane/index.js